import {
  IsUUID,
  IsEnum,
  IsOptional,
  IsString,
  MinLength,
  MaxLength,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { RelationType } from '../enums'

/**
 * DTO pour ajouter un parent/tuteur à un utilisateur par son username
 */
export class AddGuardianDto {
  @ApiProperty({
    description: "Nom d'utilisateur du parent/tuteur",
    example: 'marie.moreau',
    minLength: 1,
    maxLength: 255,
  })
  @IsString()
  @MinLength(1, { message: "Le nom d'utilisateur est requis" })
  @MaxLength(255)
  username!: string
}

/**
 * DTO pour créer une relation entre utilisateurs
 */
export class CreateRelationDto {
  @ApiProperty({ description: 'ID utilisateur cible', format: 'uuid' })
  @IsUUID()
  toUserId!: string

  @ApiProperty({ enum: RelationType, description: 'Type de relation' })
  @IsEnum(RelationType)
  type!: RelationType
}

/**
 * DTO pour lister les relations
 */
export class ListRelationsDto {
  @ApiPropertyOptional({
    enum: RelationType,
    description: 'Filtrer par type de relation',
  })
  @IsOptional()
  @IsEnum(RelationType)
  type?: RelationType
}
